import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { RingLoader, GoogleMaps } from "@/_components";
import { loadLocationsWithinRadius } from "../../../_redux/actions/appointmentActions";
import { LifeSafer, Monitech } from "../../../_helpers/BrandConstants";
import Cookies from "universal-cookie";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Australia, USA } from "../../../_helpers/CountryConstants";
import DoneIcon from "@mui/icons-material/Done";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";
import StoreIcon from "@mui/icons-material/Store";
import { langConversionHelper } from "../../../_helpers/langConversionHelper";
import Tooltip from "@mui/material/Tooltip";
import ButtonBase from "@mui/material/ButtonBase";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useParams } from "react-router-dom";

const ScheduleNow = ({
  locations,
  loadLocationsWithinRadius,
  setSelectedLocation,
  setStepSchedule,
  STEPS,
  isLoaded,
  getMap,
  setGetMap,
  selectedId,
  setSelectedId,
  nextStepAfterLocation,
}) => {
  const googleMapData = JSON.parse(sessionStorage.getItem("googleMapData"));
  const [view, setView] = useState("both");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [markers, setMarkers] = useState([]);
  const isMountedRef = useRef(null);
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const siteCountry = cookies.get("siteCountry") || USA;
  const enrolleeUser = cookies.get("lifesaferEnrollment");
  const partnerList = enrolleeUser?.locationIds?.split(",") || [];
  const enrolleeUserData = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const zipCode = sessionStorage.getItem("zipCode") || enrolleeUserData?.zip;
  const homeLat = googleMapData?.homeLat || enrolleeUserData?.homeLat;
  const homeLong = googleMapData?.homeLong || enrolleeUserData?.homeLong;
  const [defaultCenter, setDefaultCenter] = useState({ lat: 0, lng: 0 });
  const enrollNow = cookies.get("EnrollNow") || {};
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const [searchTerm, setSearchTerm] = useState(zipCode || null);
  const { storyName } = useParams();

  const deviceCode =
    enrolleeUserData?.deviceType === "Interlock" ||
    enrolleeUserData?.clientTypeId === 1
      ? "IID"
      : enrolleeUserData?.deviceType === "Portable" ||
          enrolleeUserData?.clientTypeId === 5
        ? "PAM"
        : enrolleeUserData?.deviceType === "Speed" ||
            enrolleeUserData?.clientTypeId === 6
          ? "ISA"
          : "IID";

  useEffect(() => {
    if (!isMobile) setView("both");
  }, [isMobile]);

  const handleToggleView = () => {
    setView((prev) => (prev === "both" ? "list" : "both"));
  };

  const navOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };
  const getUserLocation = async () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, navOptions);
    });
  };
  const enrollmentLocationIds =
    (enrollmentCodeData?.locationIds &&
      enrollmentCodeData?.locationIds?.split(",").map((id) => Number(id))) ||
    [];

  const updatedLocations = locations.map((loc) => ({
    ...loc,
    preferredLocation: enrollmentLocationIds.includes(loc.locationID),
  }));

  const lastScrollTop = useRef(0);

  const scrollThreshold = 100;

  const handleScroll = (e) => {
    if (isMobile === false) return;
    const currentScrollTop = e.currentTarget.scrollTop;

    const delta = currentScrollTop - lastScrollTop.current;
    if (Math.abs(delta) < scrollThreshold) return;

    if (delta > 0) {
      setView("list");
    } else {
      setView("both");
    }

    lastScrollTop.current = currentScrollTop;
  };

  // const preferredLocations = updatedLocations.filter(
  //   (loc) => loc.preferredLocation
  // );

  const handleLocationSelected = (oLocation) => {
    if (oLocation?.locationID) {
      sessionStorage.setItem("locationFlag", JSON.stringify(oLocation));
      const enrolleeUserSession =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...enrolleeUserSession,
          locationID: oLocation.locationID,
          locationId: oLocation.locationID,
        }),
      );
    }
    setSelectedId(oLocation?.locationID);
    setSelectedLocation(oLocation);
    setStepSchedule(nextStepAfterLocation || STEPS.DATE_TIME);
  };

  const getLocation = async (address) => {
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      console.error("Google Maps API not loaded");
      return [];
    }
    let geocoder = new window.google.maps.Geocoder();
    try {
      const response = await geocoder.geocode({
        address: address || "USA",
      });
      return response;
    } catch (error) {
      console.error("Error in geocode request:", error);
      return [];
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current) {
      if (
        (googleMapData !== undefined &&
          googleMapData?.homeLat &&
          googleMapData?.homeLong) ||
        (homeLat && homeLong)
      ) {
        const lat = homeLat || 0;
        const lng = homeLong || 0;

        const homeMarker = {
          key: "Home",
          lat,
          lng,
          isHome: true,
          title: googleMapData?.homeAddr1 || enrolleeUserData?.homeAddr1,
          label: "",
        };

        setMarkers((prev) => {
          const withoutHome = prev.filter((m) => m.key !== "Home");
          return [...withoutHome, homeMarker];
        });
      }
    }
    return () => (isMountedRef.current = false);
  }, [getMap, locations]);

  useEffect(() => {
    if (isMountedRef.current) {
      // Set Variables
      let lat = 0;
      let lng = 0;
      setDefaultCenter({ lat: lat, lng: lng });
      setLoading(true);
      // 0. Home lat/lng from userData if available
      if (homeLat && homeLong) {
        lat = homeLat || 0;
        lng = homeLong || 0;

        setDefaultCenter({ lat, lng });

        loadLocationsWithinRadius(
          lat,
          lng,
          300,
          deviceCode,
          enrollNow?.IsTest || false,
          brand === Monitech ? "monitechiid" : brand,
          partnerList,
          enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0,
        )
          .catch((error) => console.log("Loading locations failed! " + error))
          .finally(() => setLoading(false));
      } else {
        // 1. Get Lat/Lng from device
        getUserLocation()
          .then((x) => {
            lat = x.coords.latitude;
            lng = x.coords.longitude;

            // 2. Set our Default Center
            setDefaultCenter({ lat: lat, lng: lng });

            // 3. Get locations in the area with lat, lng, deviceType, radius 100
            loadLocationsWithinRadius(
              lat,
              lng,
              300,
              deviceCode,
              enrollNow?.IsTest || false,
              brand === Monitech ? "monitechiid" : brand,
              partnerList,
              enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0,
            )
              .catch((error) => {
                console.log("Loading locations failed! " + error);
              })
              .finally(() => {
                // setGetMap(true);
                setLoading(false);
              });
          })
          .catch((x) => {
            // 1.5. Device Geolocation Unavaible get from enrollee obj, or derive from zip code
            console.warn(`ERROR(${x.code}): ${x.message}`);
            if (zipCode !== undefined && zipCode !== null) {
              let sCountry = "USA";
              if (siteCountry === Australia) {
                sCountry = "Australia";
              }
              getLocation(zipCode + "," + sCountry).then((x) => {
                // lat = 0;
                // lng = 0;
                if (x?.results) {
                  lat = x?.results[0]?.geometry?.location?.lat();
                  lng = x?.results[0]?.geometry?.location?.lng();
                }

                // 2. Set our Default Center
                setDefaultCenter({ lat: lat, lng: lng });

                // 3. Get locations in the area with lat, lng, deviceType, radius 100
                loadLocationsWithinRadius(
                  lat,
                  lng,
                  300,
                  deviceCode,
                  enrollNow?.IsTest || false,
                  brand === Monitech ? "monitechiid" : brand,
                  partnerList,
                  enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0,
                )
                  .catch((error) => {
                    console.log("Loading locations failed! " + error);
                  })
                  .finally(() => {
                    // setGetMap(true);
                    setLoading(false);
                  });
              });
            } else {
              lat = googleMapData?.homeLat || enrolleeUserData?.homeLat || 0;
              lng = googleMapData?.homeLong || enrolleeUserData?.homeLong || 0;

              // 2. Set our Default Center
              setDefaultCenter({ lat: lat, lng: lng });

              // 3. Get locations in the area with lat, lng, deviceType, radius 100
              loadLocationsWithinRadius(
                lat,
                lng,
                300,
                deviceCode,
                enrollNow?.IsTest || false,
                brand === Monitech ? "monitechiid" : brand,
                partnerList,
                enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0,
              )
                .catch((error) => {
                  console.log("Loading locations failed! " + error);
                })
                .finally(() => {
                  // setGetMap(true);
                  setLoading(false);
                });
            }
          });
      }
    }
    return () => (isMountedRef.current = false);
  }, []);

  const handleSelectShop = (loc) => {

    if (loc?.locationID) {
      sessionStorage.setItem("locationFlag", JSON.stringify(loc));

              cookies.set(
              "EnrollNow",
              {
                ...enrollNow,
                LocationId: loc.locationID,
                Story:storyName
              },
              {
                path: "/",
                sameSite: "strict",
              }
            );

      const enrolleeUserSession =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...enrolleeUserSession,
          locationID: loc.locationID,
          locationId: loc.locationID,
        }),
      );
    }
    setSelectedId(loc?.locationID);
    setSelectedLocation(loc);
    setStepSchedule(nextStepAfterLocation || STEPS.DATE_TIME);
  };

  useEffect(() => {
    if (defaultCenter.lat !== 0) {
      setGetMap(true);
      setLoading(true);
    }
  }, [defaultCenter]);

  useEffect(() => {
    // if (typeof locations !== "undefined" && locations.length > 0) {
    const currentState = locations?.[0]?.CurrentState;
    if (
      locations?.length > 0 &&
      currentState !== "Undefined" &&
      currentState !== "None"
    ) {
      // Prepare the New Markers
      const newMarkers = locations?.map((location) => ({
        key: location.locationID,
        lat: location.latitude,
        lng: location.longitude,
        title: location.displayName,
        label: location?.address1,
        // sameDay: location.sameDay,
        sameDay: deviceCode === "ISA" ? false : location.sameDay,
        partner: location.partner,
      }));

      // Reset result markers on each search/load and keep only Home marker.
      setMarkers((prev) => {
        const homeMarker = prev.find((m) => m.key === "Home");
        return homeMarker ? [homeMarker, ...newMarkers] : newMarkers;
      });
    } else if (currentState === "None") {
      setMarkers((prev) => prev.filter((m) => m.key === "Home"));
    }
    // }
  }, [locations]);

  useEffect(() => {
    if (!selectedId) return;
    const locationExists = locations?.some(
      (location) => Number(location.locationID) === Number(selectedId),
    );
    if (!locationExists) {
      setSelectedId(null);
      setSelectedLocation(null);
    }
  }, [locations, selectedId, setSelectedId, setSelectedLocation]);

  const handleSearch = (e) => {
    if (!searchTerm) return;
    let lat = 0;
    let lng = 0;
    e?.preventDefault();
    setSearching(true);
    setSelectedId(null);
    setSelectedLocation(null);

    let sCountry = "USA";
    if (siteCountry === Australia) {
      sCountry = "Australia";
    }
    let sAddress = searchTerm || " ";
    if (
      sAddress &&
      sAddress.includes("USA") == false &&
      sAddress.includes("Australia") == false
    ) {
      sAddress = sAddress + "," + sCountry;
    }

    getLocation(sAddress)
      .then((x) => {
        if (x !== undefined && x.results !== undefined) {
          lat = x.results[0].geometry.location.lat();
          lng = x.results[0].geometry.location.lng();
          // 2. Set our Default Center
          setDefaultCenter({ lat: lat, lng: lng });
          // 3. Get locations in the area with lat, lng, deviceType, radius 100
          loadLocationsWithinRadius(
            lat,
            lng,
            300,
            deviceCode,
            enrollNow?.IsTest || false,
            brand === Monitech ? "monitechiid" : brand,
            partnerList,
            enrolleeUserData?.ClientId || enrolleeUserData?.clientId || 0,
          )
            .catch((error) => {
              console.log("Loading locations failed! " + error);
            })
            .finally(() => {
              setSearching(false);
              setLoading(false);
            });
        } else {
          // toast.error(t("outro.searchIssue"));
          setSearching(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setSearching(false);
      });
  };

  // const handleGoBack = () => {
  //   setStep(STEPS.LOCATION_ZIP);
  // };

  const transformLanguage = (languageID) => {
    let returnLanguageNames = [];

    if (!languageID) return "";

    let languageIDs = languageID?.split(",").map((id) => id.trim());

    languageIDs.forEach((id) => {
      const displayName = langConversionHelper.getLanguageDisplayName(
        id,
        i18n.language,
      );
      if (displayName) returnLanguageNames.push(displayName);
    });
    return returnLanguageNames.join(", ");
  };

  return (
    <Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 6,
        }}
      >
        <>
          <Grid
            sx={{
              width: { xs: "100%", md: "50%" },

              display: {
                xs: view === "both" || view === "list" ? "block" : "none",
                md: "block",
              },
            }}
          >
            <Paper elevation={0} sx={{ mb: 2 }}>
              <Grid
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  mb: 2,
                }}
              >
                {/* <ArrowBackIcon
                  sx={{ cursor: "pointer" }}
                  onClick={handleGoBack}
                /> */}
                <Typography fontWeight={600}>
                  {t("location.lifesaferInstallationLoc")}
                </Typography>
              </Grid>
              <Grid container alignItems="center" gap={1}>
                <Grid flex={1}>
                  <TextField
                    id="txtAddress"
                    size="small"
                    fullWidth
                    placeholder={t("outro.search")}
                    sx={{
                      flex: 1,
                      "&.MuiInputBase-input": {
                        p: "8px 5px",
                      },
                    }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ color: "#1c355e" }} />
                          </InputAdornment>
                        ),
                      },
                    }}
                    label={t("location.zipLabel")}
                    // value={searchTerm || ""}
                    value={(searchTerm || "").replace(/^ /, "")}
                    onChange={(event) => {
                      setSearchTerm(event.target.value);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    disabled={searching}
                  />
                </Grid>
                {isMobile && (
                  <Tooltip title={view === "list" ? "Map View" : "List View"}>
                    <IconButton onClick={handleToggleView}>
                      {view === "list" ? (
                        <MapOutlinedIcon sx={{ color: "#4da3ff" }} />
                      ) : (
                        <FormatListBulletedIcon sx={{ color: "#4da3ff" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Paper>
            {isMobile && view === "both" && (
              <Grid
                sx={{
                  width: "100%",
                  order: 1,
                  display: "block",
                }}
              >
                <Grid
                  container
                  justifyContent="center"
                  style={{ width: "100%", height: "100%" }}
                >
                  {getMap === false || loading === true ? (
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <RingLoader />
                    </Grid>
                  ) : (
                    <Grid
                      className="ank-google-maps-holder"
                      sx={{ width: "100%", height: "100%" }}
                    >
                      <GoogleMaps
                        defaultCenter={defaultCenter}
                        locationMarkers={markers}
                        locations={locations}
                        selectedLocation={handleLocationSelected}
                        isLoaded={isLoaded}
                        selectedLocationId={selectedId}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}

            <Grid
              onScroll={handleScroll}
              display="flex"
              flexDirection="column"
              // gap={2}
              sx={{
                overflowY: "auto",
                height: isMobile ? "calc(100vh - 150px)" : "500px",
                scrollBehavior: "smooth",
                // mt: view === "both" ? "0px" : "24px",
                // "& > :nth-child(n+2)": {
                //   mt: 2,
                // },
              }}
            >
              {searching === true ||
              locations === undefined ||
              typeof locations === "undefined" ||
              locations[0].CurrentState === "Undefined" ? (
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  style={{ marginTop: 50 }}
                >
                  <Grid>
                    <RingLoader />
                  </Grid>
                </Grid>
              ) : locations[0].CurrentState !== "Undefined" &&
                locations[0].CurrentState !== "None" ? (
                <>
                  {isMobile && view === "both" && (
                    <Grid sx={{ textAlign: "center" }}>
                      <Button
                        onClick={() => setView("list")}
                        aria-label="Show list view"
                      >
                        <ArrowForwardIosIcon
                          sx={{ transform: "rotate(270deg)" }}
                        />
                      </Button>
                    </Grid>
                  )}
                  {updatedLocations?.map((loc) => (
                    <ButtonBase
                      key={loc?.locationID}
                      onClick={() => handleSelectShop(loc)}
                      // disableRipple
                      sx={{
                        alignItems: "start",
                        textAlign: "left",
                        mt: 2,
                        [`&:nth-of-type(${isMobile ? 1 : 1})`]: {
                          mt: 0,
                        },
                      }}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          p: 1.5,
                          width: "100%",
                          border:
                            selectedId === loc?.locationID
                              ? "1px solid #91d4f0"
                              : "1px solid #e0e0e0",
                          background:
                            selectedId === loc?.locationID ? "#f1f9ff" : "none",
                        }}
                      >
                        {loc?.preferredLocation && (
                          <Typography
                            sx={{
                              display: "inline-block",
                              background: "#76bc21",
                              color: "#fff",
                              fontWeight: "500",
                              px: 1,
                              fontSize: 12,
                              mb: 1,
                            }}
                          >
                            {t("location.preferredShop")}
                          </Typography>
                        )}
                        <Grid
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography fontWeight={600} fontSize={15}>
                            {loc?.displayName}
                          </Typography>

                          {loc?.distanceFromHome
                            ? `${loc.distanceFromHome.toFixed(1)} mi`
                            : null}
                        </Grid>

                        <Typography>
                          {loc?.address1}
                          {loc?.address2 ? ", " : ""}
                          {loc?.address2}
                          {!isMobile ? ", " : ""}
                          <br
                            style={{ display: isMobile ? "" : "none" }}
                          />{" "}
                          {loc?.city}
                          {", "}
                          {loc?.state} {loc?.zip}
                        </Typography>
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "space-between",
                          }}
                        >
                          <Grid mt={1}>
                            {loc?.sameDay && (
                              <Typography
                                fontSize={15}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <DoneIcon sx={{ width: "15px" }} />
                                {t("location.appointmentsToday")}
                              </Typography>
                            )}
                            {loc?.openOnWeekends && (
                              <Typography
                                fontSize={15}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <DoneIcon sx={{ width: "15px" }} />
                                {t("location.openWeekends")}
                              </Typography>
                            )}
                            {loc?.openAfter5PM && (
                              <Typography
                                fontSize={15}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <DoneIcon sx={{ width: "15px" }} />
                                {t("location.openAfter")}
                              </Typography>
                            )}
                            {loc?.languages && (
                              <Typography
                                fontSize={15}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <TranslateIcon sx={{ width: "15px" }} />
                                {loc?.languages &&
                                  transformLanguage(loc?.languages)}
                              </Typography>
                            )}
                          </Grid>
                          <Grid>
                            <Grid
                              variant="text"
                              size="small"
                              sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "15px",
                                textDecoration:
                                  selectedId !== loc?.locationID
                                    ? "underline"
                                    : "none",
                              }}
                              // onClick={() => handleSelectShop(loc)}
                            >
                              {selectedId === loc?.locationID
                                ? t("location.myShop")
                                : t("location.setAsMyShop")}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    </ButtonBase>
                  ))}
                </>
              ) : (
                <>
                  <Grid container direction={"column"}>
                    <Grid style={{ textAlign: "center", padding: "2px" }}>
                      <StoreIcon
                        sx={{
                          height: 200,
                          width: 200,
                          opacity: 0.1,
                        }}
                      />
                      <Typography
                        sx={{
                          textAlign: "center",
                          zIndex: 10,
                          fontSize: "20px",
                        }}
                      >
                        {t("location.noLocation")}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            {/* )} */}
          </Grid>

          {!isMobile && view === "both" && (
            <Grid
              sx={{
                width: { xs: "100%", md: "50%" },
                order: { xs: 1, md: 0 },
                display: {
                  xs: view === "both" ? "block" : "none",
                  md: "block",
                },
              }}
            >
              <Grid
                container
                justifyContent="center"
                style={{ width: "100%", height: "100%" }}
              >
                {getMap === false || loading === true ? (
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <RingLoader />
                  </Grid>
                ) : (
                  <Grid
                    className="ank-google-maps-holder"
                    sx={{ width: "100%", height: "600px" }}
                  >
                    <GoogleMaps
                      defaultCenter={defaultCenter}
                      locationMarkers={markers}
                      locations={locations}
                      selectedLocation={handleLocationSelected}
                      isLoaded={isLoaded}
                      selectedLocationId={selectedId}
                    />
                    {/* <GoogleMapsLegend /> */}
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </>
      </Grid>
    </Grid>
  );
};

ScheduleNow.propTypes = {
  locations: PropTypes.array,
  loadLocationsWithinRadius: PropTypes.func,
  setSelectedLocation: PropTypes.func,
  selectedLocation: PropTypes.object,
  prefillDeviceType: PropTypes.string,
  isLoaded: PropTypes.bool,
  zipCode: PropTypes.number,
  deviceLocationType: PropTypes.string,
  setStepSchedule: PropTypes.func,
  STEPS: PropTypes.object,
  getMap: PropTypes.bool,
  setGetMap: PropTypes.func,
  setSelectedId: PropTypes.func,
  selectedId: PropTypes.number,
  nextStepAfterLocation: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
    locations: state.locations,
  };
}
const mapDispatchToProps = { loadLocationsWithinRadius };

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleNow);
